import { computeRedirectionUrl } from '../../utils/computeRedirectionUrl';

/**
 * Custom hook to unify redirection links wherever possible.
 *
 * @param {string} brandCode Brand code of property to determine applicable redirection rule
 * @param {string} marshaCode Marsha code (propertyID) of the property
 * @param {string} propertyName Property name to construct redirection URL
 * @param {string} redirectionType Custom variable to determine redirection type
 * @param {string} locale Current locale of the property (optional arg)
 * @param {string} seoNickName Correctly formatted url substring from UXL
 * @param {boolean} isBulgari Flag that needs to set if the property requires bulgari redirection
 * @param {string} location Property location that is appended to the Bulgari URL
 * @param {string} redirectionDomain The domain to be redirected to. Can be left blank if relative
 */

export function useRedirectionRules(
  brandCode?: string,
  marshaCode?: string,
  propertyName?: string,
  redirectionType?: string,
  locale?: string,
  seoNickName?: string | null,
  location?: string | null,
  redirectionDomain?: string | null
) {
  return computeRedirectionUrl(
    brandCode,
    marshaCode,
    propertyName,
    redirectionType,
    locale,
    seoNickName,
    location,
    redirectionDomain
  );
}

export { computeRedirectionUrl };
